module.exports = __webpack_public_path__ + "media/brand/scribble-blue-5bfe11c1.svg";